'use client';

import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

/* eslint-disable @next/next/no-img-element */
import { Box, Button, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';

import { MixpanelEvent } from '@/services/eventEnums';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { MixpanelTracking } from '@/services/mixpanel';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';

import { useTranslation } from 'react-i18next';
import SearchBar from '../searchBar';
import customToaster from '@/components/toast/CustomToaster';

export default function NeedImageScreen({
  showContentComponent,
  dialogFlowRef,
  setShowContentComponent,
  setOpen,
  searchBarProps,
  searchButtonProps,
  allSteps,
}: {
  showContentComponent: any;
  dialogFlowRef: any;
  setShowContentComponent: any;
  setOpen: any;
  searchBarProps: any;
  searchButtonProps: any;
  allSteps: any;
}) {
  const { t } = useTranslation('orderImagery');

  return (
    <>
      <IconButton
        name="back"
        aria-label="close-delete-item-dialog"
        className="close-btn"
        onClick={() => {
          setShowContentComponent(allSteps['main']);
        }}
        sx={{
          position: 'absolute',
          top: 5,
          left: 8,
        }}
      >
        <ArrowBackOutlinedIcon />
      </IconButton>
      <DialogTitle
        sx={{ margin: '1rem 0px 0px 0px', p: '2', textAlign: 'center' }}
        id="customized-dialog-title"
      >
        {t('searchLocation', 'Search for a location')}
      </DialogTitle>
      <IconButton
        name="Close Delete Item"
        aria-label="close-delete-item-dialog"
        className="close-btn"
        onClick={() => {
          setOpen(false);
          MixpanelTracking.getInstance().track(MixpanelEvent.EXPLORE_MOBILE_INTRO_DIALOG_CLOSE);
        }}
        sx={{
          position: 'absolute',
          right: 8,
          top: 5,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        className="mbl-intro-dialog-content"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="body2">
          {t('enterCoordinates', 'Enter coordinates or a location name to find imagery')}
        </Typography>
        <Box className="search-bar">
          <SearchBar {...searchBarProps} showNewLandingScreenRef={{ current: true }} />
        </Box>
        <Button
          sx={{ marginBottom: '10px' }}
          endIcon={<ArrowForwardOutlinedIcon sx={{ fontSize: '1rem !important' }} />}
          fullWidth
          color="primary"
          variant="contained"
          onClick={() => {
            if (searchButtonProps?.polygonCoordinates[0][0].length > 0) {
              searchButtonProps?.setIsArchiveLandingScreen(false);
              searchButtonProps.isArchiveLandingScreenRef.current = false;
              searchButtonProps?.getWebSocketPayload(searchButtonProps?.polygonCoordinates);
              setOpen(false);
              MixpanelTracking.getInstance().track(
                MixpanelEvent.EXPLORE_MOBILE_INTRO_SEARCH_IMAGERY_CLICK,
                {
                  coordinates: searchButtonProps?.polygonCoordinates,
                }
              );
            } else {
              customToaster(t('common:generalError'));
            }
          }}
        >
          {t('searchImageryTitle', 'Search Imagery')}
        </Button>
      </DialogContent>
    </>
  );
}
